import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'react-bootstrap';
import { useCurrentLanguage } from '../../../hooks/useCurrentLanguage';
import { getLanguageName } from '../../utils/utils';
import { CountryFlag } from '../CountryFlag/CountryFlag';

export const LanguageSelector = ({ className = '', size = 'sm', ...props }) => {
  const { currentLanguage, supportedLanguages, updateLanguage } = useCurrentLanguage();

  const getImageUrl = (state: string) => `https://flagcdn.com/w40/${state == 'en' ? 'gb' : state}.webp`;

  if (!currentLanguage) return null;

  return (
    <Dropdown {...props} className={className}>
      <Dropdown.Toggle variant={'dark'} size={size as 'sm' | 'lg'}>
        <img src={getImageUrl(currentLanguage.toLowerCase())} alt={currentLanguage} className={'mr-1'} />
      </Dropdown.Toggle>
      <Dropdown.Menu align={'right'} className="tootor-dropdown-menu">
      {supportedLanguages.map((lang) => (
        <Dropdown.Item
          key={lang}
          disabled={lang == currentLanguage}
          className={lang == currentLanguage ? 'language-selector-item-disabled' : ''}
          onClick={() => updateLanguage(lang)}
        >
          {lang == currentLanguage && <FontAwesomeIcon icon={faCheckCircle} className={'text-success'} />}
          {lang != currentLanguage && <CountryFlag language={lang} size="w40" />}
          <span className={'ml-2'}>{getLanguageName(lang)}</span>
        </Dropdown.Item>
      ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
